import React, { useState, useContext, useReducer } from "react";
import { RootContext } from "../../RootContextProvider";
import "./PageSettings.css";
import {
  Row,
  Col,
  Avatar,
  Input,
  Button,
  Switch,
  Upload,
  Form,
  message,
  Modal,
} from "antd";
import {
  UserOutlined,
  CloseOutlined,
  CheckOutlined,
  ExclamationCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { verticalFormLayout } from "../../utils/forms";
import {
  updateProfileInfoSettings,
  updateDisplayLogoOrUsername,
  updateNamePage,
  updateScripts,
} from "../../utils/pages";
import SimpleReactValidator from "simple-react-validator";
import PageSettingsSocial from "./PageSettingsSocials";
import { refreshContextProviderPagesOnly } from "../../utils/utils";
import { deletePage, uploadProfilePictureToAWS } from "../../utils/pages";
import { fetchPages } from "../../utils/utils";
import { useHistory } from "react-router-dom";
import PremiumTag from "../Billing/PremiumTag";

const { confirm } = Modal;

const PageSettingsContainer = () => {
  let validator = new SimpleReactValidator();
  let history = useHistory();
  const { pages, setPages, setListPages, setLinks, account } = useContext(
    RootContext
  );

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [newPageName, setNewPageName] = useState();
  const [GAScript, setGAScript] = useState(pages.GAScript);
  const [FBPixel] = useState(pages.FBPixel);
  // const [GAPixel, setGAPixel] = useState(pages.AdwordsPixel);
  const [currentPageName] = useState(pages.PageName);
  const [fileList, setFileList] = useState([]);

  const refreshContextProvider = async () => {
    let pageToRefresh = localStorage.getItem("pageToLoad");
    await refreshContextProviderPagesOnly(
      setListPages,
      setPages,
      pageToRefresh
    );
    forceUpdate();
  };

  form.setFieldsValue({
    pageUrl: pages.PageName,
    pageTitle: pages.PageTitle,
    pageDescription: pages.PageDescription,
  });

  const updatePageName = async () => {
    try {
      validator.message(
        "pageName",
        newPageName,
        "alpha_num_dash|required|min:4|max:30"
      );
      // validator.message("pageName", newPageName, "");
      if (validator.allValid()) {
        setLoading(true);
        let data = {
          PageID: pages.PageID,
          PageName: newPageName,
        };
        let res = await updateNamePage(data);
        if (res.message !== "ok") {
          message.error("😅 Opsss, ce nom de page est déjà pris.");
        } else {
          message.success("Nom de page changé avec succès.");
        }

        refreshContextProvider();
        window.location.reload();
        setLoading(false);
      } else {
        message.error(
          "Le champ doit faire entre 4 et 30 caractères contenant seulement des chiffres et lettres"
        );
      }
    } catch (e) {
      message.error("Erreur lors du changement de nom de page.");
    }
  };

  const updateProfileInfo = async (values) => {
    try {
      let data = {
        PageID: pages.PageID,
        PageTitle: values.pageTitle,
        PageDescription: values.pageDescription,
      };
      setLoading(true);
      await updateProfileInfoSettings(data);
      refreshContextProvider();
      message.success("Titre et description mis à jour");
      setLoading(false);
    } catch (e) {
      message.error("Erreur");
    }
  };

  const updateLogoOrUsernameDisplay = async (type) => {
    try {
      let data;
      if (type === "username") {
        data = {
          PageID: pages.PageID,
          updateType: type,
          DisplayUsername: !pages.DisplayPageName,
        };
      } else {
        data = {
          PageID: pages.PageID,
          updateType: type,
          HasLogo: !pages.HasLogo,
        };
      }
      setLoading(true);
      await updateDisplayLogoOrUsername(data);
      refreshContextProvider();
      setLoading(false);
    } catch (e) {
      message.error("Erreur");
    }
  };

  const updateScriptsInfo = async () => {
    try {
      let data = {
        FBPixel,
        GAScript,
        // AdwordsPixel: GAPixel,
      };
      setLoading(true);
      await updateScripts(pages.PageID, data);
      refreshContextProvider();
      message.success("Scripts mis à jour");
      setLoading(false);
    } catch (e) {
      message.error("Erreur");
    }
  };

  const onFinishFailed = () => {
    console.log("It is bugging");
  };

  const confirmDeletePage = async () => {
    confirm({
      title: `Êtes-vous sûr de vouloir supprimer votre page @${pages.PageName} ?`,
      icon: <ExclamationCircleOutlined />,
      content:
        "Si vous cliquez sur supprimer, vous perdrez toutes données reliées à cette page Linksight.",
      okText: "Supprimer",
      cancelText: "Retour",
      async onOk() {
        let res = await deletePage(pages.PageID);
        if (res.message === "ok") {
          console.log("page supprimée");
          localStorage.removeItem("pageToLoad");
          await fetchPages(
            setListPages,
            setPages,
            setLinks,
            null,
            history,
            true,
            account
          );
        } else {
          message.error("Erreur lors de la suppression");
        }
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const uploadImage = async (options) => {
    const { onSuccess, onError, file } = options;
    try {
      const fmData = new FormData();
      fmData.append("image", file);
      await uploadProfilePictureToAWS(fmData, pages.PageID);
      refreshContextProvider();
      onSuccess("Ok");
    } catch (err) {
      console.log("Error: ", err);
      new Error("Some error");
      onError({ err });
    }
  };

  const handleChange = async ({ file, fileList }) => {
    // setFileList(fileList);
    if (!file.status) {
      file.status = "error";
      setFileList([file]);
    } else {
      setFileList(fileList);
    }
    if (fileList.length === 0) {
      // setImageUrl();
    }
  };

  const handleBeforeUpload = (file) => {
    const isSmallerThan2Mb = file.size / 1024 / 1024 < 2;
    if (!isSmallerThan2Mb) {
      message.error("Votre image ne doit pas dépasser 2 Mo.");
      return false;
    } else {
      return true;
    }
  };

  const showUploadList = {
    showDownloadIcon: false,
    showRemoveIcon: false,
    showUploadList: true,
  };

  return (
    <div className="main-container page-settings">
      <div className="primary-title">Paramètres de votre page</div>
      <div className="block-container">
        {" "}
        <div className="secondary-title">Profil</div>
        <div className="block-section">
          <Row className="profile-block">
            <Col xl={4} ml={4} sm={24}>
              {" "}
              <Avatar
                size={100}
                style={{ marginTop: "20px" }}
                src={pages.PagePicture}
                icon={<UserOutlined />}
              />
              <Upload
                fileList={fileList}
                customRequest={uploadImage}
                showUploadList={showUploadList}
                onChange={handleChange}
                beforeUpload={handleBeforeUpload}
                accept=".jpg,.png"
              >
                <div className="edit-picture">
                  <div>
                    <UploadOutlined />
                  </div>
                  Modifier
                </div>
              </Upload>
              <div className="subtitle-edit-picture">(moins de 2 Mo) </div>
            </Col>
            <Col xl={20} ml={20} sm={24} style={{ width: "100%" }}>
              {" "}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "20px",
                }}
              >
                <Input
                  className="page-name-input"
                  prefix="https://linksight.me/"
                  placeholder="ma-page-linksight"
                  maxLength={30}
                  defaultValue={currentPageName}
                  onChange={(e) => {
                    setNewPageName(e.target.value);
                  }}
                  // disabled={true}
                />
                <Button
                  type="secondary"
                  icon={<CheckOutlined />}
                  size="small"
                  disabled={newPageName ? false : true}
                  loading={loading}
                  onClick={() => {
                    updatePageName();
                  }}
                />
              </div>
              <Form
                layout="vertical"
                form={form}
                onFinish={updateProfileInfo}
                onFinishFailed={onFinishFailed}
                {...verticalFormLayout}
                className="align-left form-settings"
              >
                <Form.Item
                  name="pageTitle"
                  rules={[{ max: 50, message: "50 caractères maximum" }]}
                >
                  <Input placeholder="Titre" />
                </Form.Item>
                <Form.Item
                  name="pageDescription"
                  rules={[{ max: 150, message: "150 caractères maximum" }]}
                >
                  <Input placeholder="Description" />
                </Form.Item>
                <div className="logo-section">
                  <Switch
                    checkedChildren={<CheckOutlined />}
                    unCheckedChildren={<CloseOutlined />}
                    checked={pages.HasLogo === 1 ? true : false}
                    onChange={() => {
                      updateLogoOrUsernameDisplay("logo");
                    }}
                    disabled={account.IsPaying ? false : true}
                    loading={loading}
                  />
                  <span className="content-description">Logo Linksight</span>
                  {account.IsPaying ? (
                    ""
                  ) : (
                    <PremiumTag
                      size="small"
                      hasIcon={false}
                      height="30px"
                      fontSize="13px"
                    />
                  )}
                </div>
                <div className="username-section">
                  {" "}
                  <Switch
                    checkedChildren={<CheckOutlined />}
                    unCheckedChildren={<CloseOutlined />}
                    checked={pages.DisplayPageName === 1 ? true : false}
                    onChange={() => {
                      updateLogoOrUsernameDisplay("username");
                    }}
                    loading={loading}
                  />
                  <span className="content-description">
                    Afficher nom de la page
                  </span>
                </div>
                <div className="button-spacing">
                  <Form.Item>
                    <Button
                      // className="submit-link"
                      type="secondary"
                      htmlType="submit"
                      loading={loading}
                      size="default"
                      // disabled={
                      //     !getFieldValue("Email") ||
                      //     !getFieldValue("Password") ||
                      //     hasErrors(getFieldsError())
                      // }
                    >
                      Sauvegarder
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
      <PageSettingsSocial
        refreshContextProvider={refreshContextProvider}
        loading={loading}
        setLoading={setLoading}
      />
      <div className="block-container">
        {" "}
        <div className="secondary-title">
          Scripts{" "}
          {account.IsPaying ? (
            ""
          ) : (
            <PremiumTag
              size="small"
              hasIcon={false}
              height="30px"
              fontSize="13px"
              float="unset"
              marginLeft="20px"
            />
          )}
        </div>
        <div className="block-section">
          {/* <div className="script-type">
            <div className="third-title">FACEBOOK PIXEL ID </div>
            <div className="script-input">
              <Input
                defaultValue={FBPixel}
                onChange={(e) => {
                  setFBPixel(e.target.value);
                }}
                placeholder="Facebook Pixel ID: ex 123243434324"
                maxLength={20}
                disabled={account.IsPaying ? false : true}
              />
            </div>
          </div> */}
          {/* <div className="script-type">
              <div className="third-title">GOOGLE ADWORDS CONVERSION ID</div>
              <div className="script-input">
                <Input
                  defaultValue={GAPixel}
                  onChange={(e) => {
                    setGAPixel(e.target.value);
                  }}
                  placeholder="Google Adwords: ex 1232434343"
                  maxLength={40}
                />
              </div>
            </div> */}
          <div className="script-type">
            <div className="third-title">GOOGLE ANALYTICS TRACKING ID</div>
            <div className="script-input">
              <Input
                defaultValue={GAScript}
                onChange={(e) => {
                  setGAScript(e.target.value);
                }}
                placeholder="Google Analytics ID: ex UA-000000"
                maxLength={14}
                disabled={account.IsPaying ? false : true}
              />
            </div>
          </div>
          <div className="button-spacing">
            <Button
              onClick={() => {
                updateScriptsInfo();
              }}
              loading={loading}
              type="secondary"
              disabled={account.IsPaying ? false : true}
            >
              Sauvegarder
            </Button>
          </div>
        </div>
      </div>
      <div className="block-container">
        {" "}
        <div className="danger-zone-section">
          <div className="secondary-title red">Danger zone</div>

          <Button
            onClick={() => {
              confirmDeletePage();
            }}
            type="danger"
            className="danger-btn"
          >
            Supprimer ma page Linksight
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PageSettingsContainer;
